import React, { Component } from 'react';
import $ from 'jquery';
import LoadingPage from '../../../../loading-page/loading-page';
import {Tabs, Tab } from 'react-bootstrap';
import './content-left-description.css';
import ContentLeftDescriptionSkelton from './content-left-description-skelton';
import RequestSample from '../../../../Forms/request-sample/request-sample';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';


class ContentLeftDescription extends Component {

    constructor(props) {
        super(props);

        this.state = {
            lgShow: false,
            data:this.props.data_desc.data
        }
    }

    render() {
        let lgClose = () => this.setState({ lgShow: false });
        const {error,isLoaded} = this.props.data_desc.data;
        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <ContentLeftDescriptionSkelton />;
        } else {

        return (
            <div className="row">
                <div className="col-md-12 re_desctable">

                    <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
                        <Tab eventKey={1} title="Description">
                            { ReactHtmlParser(this.state.data.data.description.full_description) }

                            <div className="row text-center">
                                <button class="spk_ana open-AddBookDialog btn_bg hidden-xs" id="d2"
                                        onClick={() => this.setState({lgShow: true})} data-id={this.state.data.data.title}>
                                    <i class="fa fa-download"></i>Download Free Sample NOW
                                </button>
                                <button class="spk_ana open-AddBookDialog btn_bg open-AddBookDialog_title_pt visible-xs" id="d2"
                                        onClick={() => this.setState({lgShow: true})} data-id={this.state.data.data.title}>
                                    <i class="fa fa-download"></i> Download Free Sample NOW
                                </button>
                            </div>
                        </Tab>
                        <Tab eventKey={2} title="Table of Contents">
                            { ReactHtmlParser(this.state.data.data.content.table) }

                            <div className="row text-center">
                                <button class="spk_ana open-AddBookDialog btn_bg hidden-xs" id="d2"
                                        onClick={() => this.setState({lgShow: true})} data-id={this.state.data.data.title}>
                                    <i class="fa fa-download"></i>Download Free Sample NOW
                                </button>
                                <button class="spk_ana open-AddBookDialog btn_bg open-AddBookDialog_title_pt visible-xs" id="d2"
                                        onClick={() => this.setState({lgShow: true})} data-id={this.state.data.data.title}>
                                    <i class="fa fa-download"></i> Download Free Sample NOW
                                </button>
                            </div>
                        </Tab>
                    </Tabs>



                </div>
                <RequestSample show={this.state.lgShow} data={this.state.data} onHide={lgClose}/>
            </div>
        )}
    }




}


export default ContentLeftDescription;


// WEBPACK FOOTER //
// ./src/report-description/content/content-left/content-left-description/content-left-description.js